// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_5S9","toggle":"styles_toggle__3m9I9","preview":"styles_preview__2Or5U"};